import styled, { css } from 'styled-components';
import { Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { theme } from 'modules/core/theme';
import { ROBOTO_FONT_FAMILY } from 'modules/core/theme/typography';
import { BS_MODAL_BACKDROP_ZINDEX, STATIC_IMAGE_URLS } from 'modules/core/constants';
import { Icon } from 'modules/core/components/Icon';
import { WindowBreakpoints } from 'modules/core/enums/windowBreakpoints.enum';

const sideBarLinkMixin = css`
  position: relative;
  border-radius: 0;
  font-size: 15px;
  padding: 7.5px 7px;
  width: 100%;
  color: ${theme.colors['white']};
  display: flex;

  &:hover {
    text-decoration: none;
    background-color: ${theme.colors['white-4']};
    color: ${theme.colors['blue-5']}!important;

    & ${Icon} {
      filter: brightness(1);
    }
  }
`;

export const SideBarMenu = styled.div<{
  open: boolean;
}>`
  width: ${({ open }) => (open ? 'auto' : '42px')};
  background-color: ${theme.colors['blue-5']};
  transition: width 0.5s ease;
  height: 100%;
  position: fixed;
  top: 0;
  max-width: 85%;
  z-index: ${({ open }) => (open ? '1001' : '9')};
  overflow-y: ${({ open }) => (open ? 'auto' : 'visible')};
  .nav-item {
    width: ${({ open }) => (open ? 'auto' : '42px')};
  }

  @media (max-width: ${WindowBreakpoints.modalPageView}px) {
    z-index: ${BS_MODAL_BACKDROP_ZINDEX - 1};
  }
`;

export const Overlay = styled.div<{
  open: boolean;
}>`
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  z-index: ${({ open }) => (open ? '31' : '8')};
  background-color: rgba(0, 0, 0, 0.4);
  -o-transition: opacity .2s ease 0s,visibility .2s ease 0s;
  transition: opacity .2s ease 0s,visibility .2s ease 0s;

  opacity: ${({ open }) => (open ? '1' : '0')};
  visibility: ${({ open }) => (open ? 'visible' : 'hidden')};

  @media (max-width: ${WindowBreakpoints.modalPageView}px) {
    z-index: ${({ open }) => (open ? BS_MODAL_BACKDROP_ZINDEX - 1 : '8')};
  }
}
`;

export const SideBarList = styled(Nav)`
  display: flex;
  flex-direction: column;
`;

export const SideBarListLink = styled(NavLink)<{
  selected: boolean;
  $smallFont?: boolean;
}>`
  background-color: ${({ selected }) => selected && theme.colors['white']};
  padding: ${({ $smallFont }) => $smallFont && '6px 10px !important'};
  text-decoration: none;

  ${sideBarLinkMixin};
  color: ${({ selected }) => selected && theme.colors['blue-5']};

  & ${Icon} {
    filter: ${({ selected }) => `brightness(${selected ? 1 : 100})`};
  }
`;

export const SideBarListExternalLink = styled.a<{
  selected: boolean;
  $smallFont?: boolean;
}>`
  background-color: ${({ selected }) => selected && theme.colors['white']};
  padding: ${({ $smallFont }) => $smallFont && '10px !important'};
  ${sideBarLinkMixin};
  cursor: pointer;
  text-decoration: none;
  color: ${({ selected }) => selected && theme.colors['blue-5']} !important;

  & ${Icon} {
    filter: ${({ selected }) => `brightness(${selected ? 1 : 100})`};
  }
`;

export const MenuItemTitle = styled.span<{
  open: boolean;
  $smallFont?: boolean;
}>`
  white-space: nowrap;
  margin-left: 10px;
  font-family: ${ROBOTO_FONT_FAMILY};
  text-transform: ${({ $smallFont }) => ($smallFont ? 'none' : 'uppercase')};
  font-size: ${({ $smallFont }) => $smallFont && '0.92em'};
  display: ${({ open }) => (open ? 'inline-flex' : 'none')};
  align-items: center;
`;

export const ToggleMenuIcon = styled.div<{
  open: boolean;
  isExternal?: boolean;
}>`
  display: flex;
  padding: 10px 7px;
  position: relative;
  z-index: 36;
  height: ${({ isExternal }) => (isExternal ? '22px' : '42px')};
  align-items: center;
  cursor: pointer;
  justify-content: space-between;

  span {
    display: inline-block;
    position: relative;
    transition: all 0.5s ease;
    transform: ${({ open }) => (open ? 'rotate(-180deg)' : 'rotate(0)')};
    top: 1px;
    left: ${({ open }) => (open ? '0' : '8px')};
    width: 15px;
    height: 15px;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: url(${STATIC_IMAGE_URLS.icons.play});
  }
`;

export const SideBarHeader = styled.div<{
  open: boolean;
}>`
  display: ${({ open }) => (open ? 'block' : 'none')};
  color: ${theme.colors['white']};
  font-family: ${ROBOTO_FONT_FAMILY};
  text-transform: uppercase;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.5px;
  margin-right: auto;
  margin-left: 2px;
`;
